import { Pipe, PipeTransform } from '@angular/core';
import { IdentifierType } from '@app/core/_models/member-interface';

@Pipe({
  name: 'unsubscribeTranslationKeyWithIdentifierType',
})

export class UnsubscribeTranslationKeyWithIdentifierTypePipe implements PipeTransform {
  public transform(translationKeyPart: string, identifierType: IdentifierType): string {
    return `unsubscription.${identifierType}.${translationKeyPart}`;
  }
}
